import { render, staticRenderFns } from "./MtNewsForm.vue?vue&type=template&id=3441da48&"
import script from "./MtNewsForm.vue?vue&type=script&lang=js&"
export * from "./MtNewsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports